import { TFunction } from "i18next";

import { ICoursesCalendarToolbarSelectOption } from "./courses-calendar-toolbar.models";

export const pickAllowedToolbarSelectValue = <T extends string>(
  candidate: string,
  allowedValues: readonly T[],
): T | undefined => allowedValues.find(v => v === candidate);

export const buildCoursesCalendarToolbarSelectOptions = <T extends string>(
  filters: readonly T[],
  labelKeys: Record<T, string>,
  translate: TFunction,
): ICoursesCalendarToolbarSelectOption<T>[] =>
  filters.map(filter => ({
    value: filter,
    label: translate(labelKeys[filter]),
  }));
